const formWrapper = document.querySelector('.contact-form-wrapper');
const form = document.getElementById('form');

// Fält från formuläret
const bankruptcyName = document.getElementById('bankruptcyName');
const bankruptcyOrgNrOrPersNr = document.getElementById('bankruptcyOrgNrOrPersNr');
const username = document.getElementById('name');
const orgNrOrPersNr = document.getElementById('orgNrOrPersNr');
const contactPerson = document.getElementById('contactPerson');
const email = document.getElementById('mail');
const zipCode = document.getElementById('zipCode');
const postalAddress = document.getElementById('postalAddress');
const total = document.getElementById('total');
const comment = document.getElementById('comment');
const file = document.getElementById('file');
const phone = document.getElementById('phone');
const co = document.getElementById('co');
const address = document.getElementById('address');

// Fält för att populera felmeddelande:
const formErrorMessage = document.querySelector('.form-error-message');

// Fält för att populera successmeddelande:
const formSuccessMessage = document.querySelector('.form-success-message');

// Hanterar formulärets submit-event
if (form != null) {
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        sendForm();
    });
}

// Skickar formuläret
const sendForm = () => {
    formErrorMessage.textContent = ''; // Rensa tidigare felmeddelanden
    // Kontrollera om en fil är uppladdad
    const hasFile = file && file.files && file.files.length > 0;

    if (hasFile) {
        // Använd FormData för filuppladdning
        const formData = new FormData();
        formData.append('name', username ? username.value.trim() : '');
        formData.append('mail', email ? email.value.trim() : '');
        formData.append('phone', phone ? phone.value.trim() : '');
        formData.append('bankruptcyName', bankruptcyName ? bankruptcyName.value.trim() : '');
        formData.append('bankruptcyOrgNrOrPersNr', bankruptcyOrgNrOrPersNr ? bankruptcyOrgNrOrPersNr.value.trim() : '');
        formData.append('orgNrOrPersNr', orgNrOrPersNr ? orgNrOrPersNr.value.trim() : '');
        formData.append('contactPerson', contactPerson ? contactPerson.value.trim() : '');
        formData.append('comment', comment ? comment.value.trim() : '');
        formData.append('co', co ? co.value.trim() : '');
        formData.append('address', address ? address.value.trim() : '');
        formData.append('zipCode', zipCode ? zipCode.value.trim() : '');
        formData.append('postalAddress', postalAddress ? postalAddress.value.trim() : '');
        formData.append('total', total ? total.value.trim() : '');
        formData.append('file', file.files[0]);

        // Skicka med FormData (ingen Content-Type header)
        fetch('/wp-json/lindskog-malmstrom/v1/contact', {
            method: 'POST',
            body: formData,
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(data => {
                    console.error('Valideringsfel:', data.errors || data.message);
                    throw new Error('Valideringsfel');
                });
            }
            return response.json();
        })
        .then(data => {
            if (data.success) {
                formWrapper.classList.add('submitted');
                formSuccessMessage.textContent = `Din anmälan är mottagen och en bekräftelse skickas till din e-postadress. Referensnummer: ${data.data.referenceNumber}`;
            } else {
                console.error('Valideringsfel:', data.errors || data.message);
                formErrorMessage.textContent = data.errors ? data.errors.join(', ') : data.message;
            }
        })
        .catch(error => {
            console.error('Ett fel uppstod:', error);
            formErrorMessage.textContent = 'Ett fel uppstod, vänligen försök igen senare.';
        });
    } else {
        // Bygg JSON-objektet direkt (ingen fil)
        const payload = {
            name: username ? username.value.trim() : '',
            mail: email ? email.value.trim() : '',
            phone: phone ? phone.value.trim() : '',
            bankruptcyName: bankruptcyName ? bankruptcyName.value.trim() : '',
            bankruptcyOrgNrOrPersNr: bankruptcyOrgNrOrPersNr ? bankruptcyOrgNrOrPersNr.value.trim() : '',
            orgNrOrPersNr: orgNrOrPersNr ? orgNrOrPersNr.value.trim() : '',
            contactPerson: contactPerson ? contactPerson.value.trim() : '',
            comment: comment ? comment.value.trim() : '',
            co: co ? co.value.trim() : '',
            address: address ? address.value.trim() : '',
            zipCode: zipCode ? zipCode.value.trim() : '',
            postalAddress: postalAddress ? postalAddress.value.trim() : '',
            total: total ? total.value.trim() : '',
        };

        // Skicka datan som JSON
        fetch('/wp-json/lindskog-malmstrom/v1/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(data => {
                    console.error('Valideringsfel:', data.errors || data.message);
                    throw new Error('Valideringsfel');
                });
            }
            return response.json();
        })
        .then(data => {
            if (data.success) {
                formWrapper.classList.add('submitted');
                formSuccessMessage.textContent = `Din anmälan är mottagen och en bekräftelse skickas till din e-postadress. Referensnummer: ${data.data.referenceNumber}`;
            } else {
                console.error('Valideringsfel:', data.errors || data.message);
                formErrorMessage.textContent = 'Valideringsfel. Vänligen kontrollera formuläret.';
            }
        })
        .catch(error => {
            console.error('Ett fel uppstod:', error);
            formErrorMessage.textContent = 'Ett fel uppstod, det gick inte att skicka formuläret, vänligen försök igen senare.';
        });
    }
};

